import React, { useState, useEffect, useRef } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Drawer, Input, Form, Select } from 'antd'
import notification from 'mrx-notification'
import styles from './CreateAwsSetting.module.scss'
import { PropsFromRedux, connector } from './container'

const CreateAuthorizeSetting = (props: PropsFromRedux) => {
  const [isVisible, setVisible] = useState(false)
  const refEl = useRef<Input>(null)

  const { isLoading, createAwsSetting } = props

  useEffect(() => {
    if (isVisible) {
      refEl.current && refEl.current.focus()
    }
  }, [isVisible])

  const showDrawer = () => {
    setVisible(!isVisible)
  }

  const [form] = Form.useForm()

  const handleClose = () => {
    setVisible(false)
    form.resetFields()
  }

  const onFinishHandler = async (values: any) => {
    const isSaved = await createAwsSetting({
      name: values.name,
      accessKeyId: values.accessKey,
      secretAccessKey: values.secretAccessKey,
      region: values.region
    })
    if (isSaved) {
      notification.success({
        message: 'Successfully',
        description: 'Aws Setting was created successfully!'
      })
      handleClose()
    }
  }

  return (
    <>
      <Button type='primary' onClick={showDrawer}>
        <PlusOutlined />
        CREATE
      </Button>
      <Drawer title='Create AWS Setting' width='400' onClose={handleClose} visible={isVisible} forceRender>
        <Form layout='vertical' hideRequiredMark onFinish={onFinishHandler} form={form}>
          <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Please input AWS Setting name!' }]}>
            <Input ref={refEl} />
          </Form.Item>
          <Form.Item
            name='accessKey'
            label='Access Key'
            rules={[{ required: true, message: 'Please input AWS Setting access key!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='secretAccessKey'
            label='Secret Access Key'
            rules={[{ required: true, message: 'Please input AWS Setting secret access key!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='region'
            label='Region'
            rules={[{ required: true, message: 'Please select AWS Setting region!' }]}
          >
            <Select>
              <Select.Option key='1' value='us-east-1'>
                US-East-1
              </Select.Option>
            </Select>
          </Form.Item>
          <div
            style={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right'
            }}
          >
            <Button onClick={handleClose} className={styles.createButton}>
              Close
            </Button>
            <Button type='primary' htmlType='submit' loading={isLoading}>
              Create
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  )
}

export default connector(CreateAuthorizeSetting)
